import { useTranslation } from 'react-i18next'

import { resolveMediaDisplayUrl } from '@/features/studio/lib/media-display'
import { AudioWavePlayer } from '@/features/studio/components/AudioWavePlayer'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/shared/components/ui/dialog'

export function MediaPreviewModal({
  open,
  onClose,
  url,
  kind,
  title,
}: {
  open: boolean
  onClose: () => void
  url: string
  kind: 'video' | 'audio' | 'image'
  title?: string
}) {
  const { t } = useTranslation()
  const displayUrl = resolveMediaDisplayUrl(url)

  if (!displayUrl) return null

  return (
    <Dialog open={open} onOpenChange={(next) => !next && onClose()}>
      <DialogContent
        showCloseButton
        className="max-w-3xl gap-0 overflow-hidden p-0 sm:max-w-3xl"
      >
        <DialogHeader className="border-b px-4 py-3 text-left">
          <DialogTitle className="truncate text-sm font-medium">
            {title ?? t('assets.mediaPreview')}
          </DialogTitle>
        </DialogHeader>
        <div className="flex items-center justify-center bg-muted/30 p-4 sm:p-6">
          {kind === 'image' ? (
            <img
              src={displayUrl}
              alt={title ?? ''}
              className="max-h-[min(70vh,720px)] w-full rounded-lg object-contain"
            />
          ) : kind === 'video' ? (
            <video
              src={displayUrl}
              controls
              autoPlay
              playsInline
              className="max-h-[min(70vh,720px)] w-full rounded-lg bg-black"
            />
          ) : (
            <div className="w-full max-w-md">
              <AudioWavePlayer variant="card" src={displayUrl} title={title} />
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  )
}
